import React from 'react';

import { styled } from '@mui/material/styles';
import ButtonMui from '@mui/material/Button';
import { privateStyles } from './styles';

const ButtonRaw = React.forwardRef((props, ref) => <ButtonMui ref={ref} {...props} />);

const Button = styled(ButtonRaw)(privateStyles);

export { Button };
